import { NavLink } from "react-router-dom";
import { AdminMenus } from "./admin";
import { UserMenus } from "./user";


export const FindMenus = (type) => {
  return {
    admin: AdminMenus,
    user: UserMenus,
  }?.[type]?.map((d, i) => {
    if (d?.children) {
      return {
        ...d,
        icon: <i className={`${d.icon} fs-1`} />,
        label: d.label,
        children: d?.children?.map((child) => ({
          ...child,
          icon: child.icon ? <i className={`${child.icon} fs-3`} /> : null,
          label: <NavLink to={child.key}>{child.label}</NavLink>,
        })),
      };
    }

    return {
      ...d,
      icon: <i className={`${d.icon} fs-1`} />,
      label: <NavLink to={d.key}>{d.label}</NavLink>,
    };
  });
};
